import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
    applyFeatureSelection, changeRoom, setCurrentConfigCode, setPopupState, setSnackbarMessage, updateTotalPrice,
} from '../model/configuratorSlice';
import { EndPoints, PopupState, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';

export default function LoadConfigurationCodeService() {
    const { promotionSlug, currentUnit, rooms } = useSelector(state => state.configurator);
    const dispatch = useDispatch();

    return useMutation(['loadConfigurationCodeQuery'], (code) => {
        const unitId = currentUnit !== null ? currentUnit.id : 0;
        const loadConfigCodeUrl = `${EndPoints.LoadConfigCodeUrl}/${promotionSlug}/unit/${unitId}/code/${code}`;
        const config = {
            headers: {
                [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
            },
        };
        axios
            .get(loadConfigCodeUrl, config)
            .then((response) => {
                console.log(`load config code: ${response.data}`);
                dispatch(setPopupState(PopupState.None));
                dispatch(applyFeatureSelection(response.data.feature_selection));
                dispatch(setCurrentConfigCode(code));
                dispatch(updateTotalPrice());
                dispatch(changeRoom(rooms[0].id));
                dispatch(setSnackbarMessage(`${FeedbackMessages.ConfigurationCodeLoadedSuccesfully} ${code}`));
            })
            .catch((error) => {
                dispatch(setSnackbarMessage(FeedbackMessages.ConfigurationCodeNotFound));
            });
    });
}
